// ./MobileDisplay.jsx
import React, { useState, useEffect } from "react";
import "./../common/style.css";
import TimerButton from "../common/TimerButton";
import SetsButton from "../common/SetsButton";
import SuccessButton from "../common/SuccessButton";

const MobileDisplay = () => {
  const [openIndex, setOpenIndex] = useState(null); // Toggle for instructions
  const [showGifIndex, setShowGifIndex] = useState(null); // Toggle for GIF

  // Dummy data for static display
  const exercises = [
    {
      exercise_id: 1,
      name: "Push-Up",
      equipment_names: "Bodyweight",
      primary_muscle: "Chest",
      secondary_muscle: "Triceps",
      tertiary_muscle: "Shoulders",
      tempo: "2-0-1",
      sets: 3,
      reps: "10-12",
      rest: "1:30 min",
      rest_seconds: 5,
      instructions: "Start in a plank position, lower your body until your chest is just above the floor, then push back up.",
    },
    {
      exercise_id: 2,
      name: "Squat",
      equipment_names: "Bodyweight",
      primary_muscle: "Quads",
      secondary_muscle: "Glutes",
      tempo: "3-0-3",
      sets: 4,
      reps: "15",
      rest: "2:00 min",
      rest_seconds: 7,
      instructions: "Stand with feet shoulder-width apart, lower your hips down and back until thighs are parallel to the ground, then stand back up.",
    },
    {
      exercise_id: 3,
      name: "Plank",
      equipment_names: "Bodyweight",
      primary_muscle: "Core",
      tempo: "3-0-3",
      sets: 4,
      reps: "1:00 min",
      rest: "1:00 min",
      rest_seconds: 5,
      instructions: "Hold a plank position with elbows on the ground and body in a straight line from head to heels.",
    },
  ];

  // Initialize state for each exercise
  const initialExerciseStates = exercises.reduce((acc, exercise) => {
    acc[exercise.exercise_id] = {
      sets: 0,
      countdown: exercise.rest_seconds,
      timerActive: false,
      completed: false,
    };
    return acc;
  }, {});

  const [exerciseStates, setExerciseStates] = useState(initialExerciseStates);

  // Handler for SetsButton click
  const handleSetsButtonClick = (exercise_id, rest_seconds) => {
    setExerciseStates((prevStates) => ({
      ...prevStates,
      [exercise_id]: {
        ...prevStates[exercise_id],
        sets: prevStates[exercise_id].sets + 1,
        countdown: rest_seconds,
        timerActive: true,
      },
    }));
  };

  // useEffect to handle timers
  useEffect(() => {
    // Create an interval
    const interval = setInterval(() => {
      setExerciseStates((prevStates) => {
        const newStates = { ...prevStates };
        exercises.forEach((exercise) => {
          const state = newStates[exercise.exercise_id];
          if (state.timerActive && state.countdown > 0) {
            newStates[exercise.exercise_id].countdown -= 1;
            if (newStates[exercise.exercise_id].countdown === 0) {
              // If current set is the last set, mark as completed
              if (state.sets >= exercise.sets) {
                newStates[exercise.exercise_id].completed = true;
              }
              // Deactivate timer
              newStates[exercise.exercise_id].timerActive = false;
            }
          }
        });
        return newStates;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [exercises]);

  const toggleInstructions = (index) => setOpenIndex(openIndex === index ? null : index);
  const toggleGif = (index) => setShowGifIndex(showGifIndex === index ? null : index);

  return (
    <div className="loader">
      <div className="loading-text">
        Loading<span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </div>
    </div>
  );
};

export default MobileDisplay;
